import PropertyRightListContainer from "../../../components/property/listing/PropertyRightList";

const PropertyRightList = () => {
  return <PropertyRightListContainer />;
};

export default PropertyRightList;
